import { defineMessages } from 'react-intl'

const scope = `procurify.components.Budgets.BudgetCategoryImporterModal`

export default defineMessages({
  oldImporterTitle: {
    id: `${scope}.oldImporterTitle`,
    defaultMessage: 'Budget Categories',
  },
  budgetCategoryImporterModalTitle: {
    id: `${scope}.budgetCategoryImporterModalTitle`,
    defaultMessage: 'Import Budget Category',
  },
  importerTitle: {
    id: `${scope}.importerTitle`,
    defaultMessage: 'Budgets',
  },
  budgetsImporterModalTitle: {
    id: `${scope}.budgetsImporterModalTitle`,
    defaultMessage: 'Import Budgets',
  },
})
